// values from this file are used in case there is no event in global/events.js, that can be used

const LEFT_MENU_PREFIX = 'leftMenu';
export const LEFT_MENU_OPEN = `${LEFT_MENU_PREFIX}:open`;
export const LEFT_MENU_CLOSE = `${LEFT_MENU_PREFIX}:close`;
export const LEFT_MENU_CHANGE = `${LEFT_MENU_PREFIX}:change`;
export const LEFT_MENU_EXPAND = `${LEFT_MENU_PREFIX}:expand`;
export const LEFT_MENU_COLLAPSE = `${LEFT_MENU_PREFIX}:collapse`;

const RIGHT_MENU_PREFIX = 'rightMenu';
export const RIGHT_MENU_OPEN = `${RIGHT_MENU_PREFIX}:open`;
export const PROJECT_COLORS_OPEN = `${RIGHT_MENU_PREFIX}:projectColors:open`;

const USER_PREFIX = 'user';
export const USER_LOGIN = `${USER_PREFIX}:login`;
export const USER_SIGNUP = `${USER_PREFIX}:signup`;
export const USER_LOGOUT = `${USER_PREFIX}:logout`;

const SEARCH_PREFIX = 'search';
export const SEARCH_TEMPLATES = `${SEARCH_PREFIX}:templates`;
export const SEARCH_ELEMENTS = `${SEARCH_PREFIX}:elements`;
export const SEARCH_TEXTURES = `${SEARCH_PREFIX}:textures`;
export const SEARCH_BACKGROUNDS = `${SEARCH_PREFIX}:backgrounds`;
export const SEARCH_FONTS = `${SEARCH_PREFIX}:fonts`;
export const SEARCH_PHOTOS = `${SEARCH_PREFIX}:photos`;
export const SEARCH_MOCKUPS = `${SEARCH_PREFIX}:mockups`;
export const SEARCH_AI_ART = `${SEARCH_PREFIX}:aiArt`;

export const ONBOARDING_STEP = `onboarding:step`;

// Upload events
const UPLOAD_PREFIX = 'upload';
export const UPLOAD_MEDIA_CLICK = `${UPLOAD_PREFIX}:mediaClick`;
export const UPLOAD_FONT_BUTTON_CLICK = `${UPLOAD_PREFIX}:customFontClick`;
export const UPLOAD_CREATE = `${UPLOAD_PREFIX}:create`;
export const UPLOAD_CAUTION_MODAL_CLOSE = `${UPLOAD_PREFIX}:cautionModalClose`;
export const UPLOAD_CHOOSE_FONTS_CLICK = `${UPLOAD_PREFIX}:chooseFontsClick`;
export const UPLOAD_FONTS_CHOSEN = `${UPLOAD_PREFIX}:fontsChosen`;
export const UPLOAD_FONTS_PICKER_CLOSE = `${UPLOAD_PREFIX}:filePickerClose`;
export const UPLOAD_FONTS_CANCELLED = `${UPLOAD_PREFIX}:uploadCancelled`;
export const UPLOAD_FONTS_RENAMED = `${UPLOAD_PREFIX}:fontRenamed`;
export const UPLOAD_FONTS_STYLE_RENAMED = `${UPLOAD_PREFIX}:fontStyleRenamed`;
export const UPLOAD_FONTS_STYLE_DELETED = `${UPLOAD_PREFIX}:fontStyleDeleted`;
export const UPLOAD_FONTS_ADDMORE = `${UPLOAD_PREFIX}:addMoreFontsClick`;
export const UPLOAD_FONTS_ADD_TO_LIB = `${UPLOAD_PREFIX}:addFontToLibrary`;

export const USER_NAVIGATION_CLICK = 'userNavigation:click';
export const THEME_SWITCH = 'theme:switch';

// Notification events
const NOTIFICATION_PREFIX = 'notification';
export const CLICK_NOTIFICATION = `${NOTIFICATION_PREFIX}:click`;

// Invite friends modal and panel events
const INVITE_PREFIX = 'invite';
export const PROJECTLIMIT_PANEL = `${INVITE_PREFIX}:panelShown`;
export const PROJECTLIMIT_PANEL_CLICK = `${INVITE_PREFIX}:panelActionClick`;

export const SHARE_SELECTION_LINK_PREFIX = 'selection';
export const SHARE_SELECTION_LINK_CREATE = `${SHARE_SELECTION_LINK_PREFIX}:create`;
export const SHARE_SELECTION_LINK_VIEW = `${SHARE_SELECTION_LINK_PREFIX}:view`;

const UPGRADE_MODAL_PREFIX = 'upgradeModal';
export const UPGRADE_MODAL_SHOW = `${UPGRADE_MODAL_PREFIX}:show`;
export const UPGRADE_MODAL_CLICK = `${UPGRADE_MODAL_PREFIX}:click`;

const SUBSCRIPTION_POP_UP_PREFIX = 'subscriptionPopUp';
export const SUBSCRIPTION_POP_UP_CLICK = `${SUBSCRIPTION_POP_UP_PREFIX}:click`;
export const SUBSCRIPTION_POP_UP_CLOSE = `${SUBSCRIPTION_POP_UP_PREFIX}:close`;

const PROJECT_LIST_MODAL_PREFIX = 'selectProjectModal';
export const PROJECT_LIST_MODAL_SHOW = `${PROJECT_LIST_MODAL_PREFIX}:show`;
export const PROJECT_LIST_MODAL_PROJECT_CLICK = `${PROJECT_LIST_MODAL_PREFIX}:projectClick`;

export const POPUP_LEARN_MORE_CLICK = `${INVITE_PREFIX}:popupLearnMoreClick`;

// Bottom menu
export const SHORTCUTS_MENU_OPEN = `shortcuts:open`;

// Authentication
const AUTHENTICATION_PREFIX = 'authentication';
// This guy is used for anything that opens signup e.g. clicking `Use Design` on the website
// we need to pass `label` with source of the event
export const AUTHENTICATION_CLICK_SIGNUP = `${AUTHENTICATION_PREFIX}:clickSignup`;
export const AUTHENTICATION_CLICK_LOGIN = `${AUTHENTICATION_PREFIX}:clickLogin`;
export const AUTHENTICATION_SWITCH = `${AUTHENTICATION_PREFIX}:switchView`;
export const AUTHENTICATION_SHOW = `${AUTHENTICATION_PREFIX}:show`;
export const AUTHENTICATION_FORGOT_PASSWORD = `${AUTHENTICATION_PREFIX}:passwordForgot`;

// Signup
const SIGNUP_PREFIX = 'signup';
export const CREATE_ACCOUNT = `${SIGNUP_PREFIX}:createAccount`;
export const SIGNUP_SERVER_ERROR = `${SIGNUP_PREFIX}:serverError`;
export const SIGNUP_LOCAL_ERROR = `${SIGNUP_PREFIX}:localError`;
export const SIGNUP_MOBILE = `${SIGNUP_PREFIX}:mobile`;

// Login
const LOGIN_PREFIX = 'login';
export const LOGIN = `${LOGIN_PREFIX}:createAccount`;
export const LOGIN_SERVER_ERROR = `${LOGIN_PREFIX}:serverError`;
export const LOGIN_LOCAL_ERROR = `${LOGIN_PREFIX}:localError`;

// Social
const SOCIAL_PREFIX = 'social';
export const SOCIAL_FACEBOOK = `${SOCIAL_PREFIX}:facebook`;
export const SOCIAL_GOOGLE = `${SOCIAL_PREFIX}:google`;

// Form
export const TOGGLE_PASSWORD = `${LOGIN_PREFIX}:togglePassword`;

export const TEMPLATE_BOOKMARK = `template:bookmark`;
export const FOLLOW_CREATE = `follow:create`;

const DOWNLOAD_PREFIX = 'downloadPanel';
export const CLICK_DOWNLOAD_PANEL_REMOVE_BACKGROUND_SWITCH = `${DOWNLOAD_PREFIX}:removeBackgroundClick`;
export const CLICK_DOWNLOAD_PANEL_OPTIMIZE_QUALITY_SWITCH = `${DOWNLOAD_PREFIX}:optimizeQualityClick`;
export const CLICK_DOWNLOAD_PANEL_EXPORT_LABEL = `${DOWNLOAD_PREFIX}:exportLabelClick`;

// Growthbook (A/B testing)
const AB_PREFIX = 'abTest';
export const AB_TRACKINGCALLBACK = `${AB_PREFIX}:trackingCallback`;

// Background removal
export const BACKGROUND_REMOVAL_CLICK = `backgroundRemoval:click`;

export const VECTORIZING_CLICK = `vectorizing:click`;

export const UPSCALER_CLICK = `aiImageUpscaler:click`;

// AI
const AI_PREFIX = 'ai';

export const AI_UPSCALE_IMAGE_TOO_BIG = `${AI_PREFIX}:upscaleImageTooBig`;
export const AI_UPSCALE_IMAGE_TOO_SMALL = `${AI_PREFIX}:upscaleImageTooSmall`;

export const AI_GENERATE_IMAGE_CLICK = `${AI_PREFIX}:generateImageClick`;
export const AI_GENERATE_IMAGE_MODEL_SELECTION = `${AI_PREFIX}:generateImageModelSelection`;
export const AI_USAGE_PROMPT_CLICK = `${AI_PREFIX}:usagePromptClick`;
export const AI_USAGE_PROMPT_CLOSE = `${AI_PREFIX}:usagePromptClose`;

export const AI_GENERATE_VECTOR_IMAGE_CLICK = `${AI_PREFIX}:generateVectorImageClick`;
export const AI_GENERATE_PRODUCT_BACKGROUND = `${AI_PREFIX}:generateProductBackground`;

export const AI_ART_PROMPT_BOX_EMPTY_CLICK = `${AI_PREFIX}:editorAIArtFeedPromptBoxEntryClick`;

// AI Art Feed - Prompt info
export const AI_VIEW_PROMPT_ADD_TO_ARTBOARD_CLICK = `${AI_PREFIX}:imageViewPromptAddToArtboardClick`;
export const AI_VIEW_PROMPT_USE_PROMPT_CLICK = `${AI_PREFIX}:imageViewPromptUsePromptClick`;
export const UPLOADS_AI_GEN_VIEW_PROMPT_EXPAND_CLICK = `${AI_PREFIX}:uploadsAiImagePromptInfoExpandClick`;

// AI - Logo
export const AI_LOGO_DISCLAIMER_CLICK = `${AI_PREFIX}:logoGenProjectDisclaimerClick`;
export const AI_LOGO_SUGGEST_PROMPT = `${AI_PREFIX}:suggestLogoPromptClick`;

// AI - Design
const AI_DESIGN_GEN_PREFIX = `${AI_PREFIX}DesignGen`;
export const AI_DESIGN_GEN_BANNER_CLICK = `${AI_DESIGN_GEN_PREFIX}:bannerClick`;
export const AI_DESIGN_SUGGEST_PROMPT_CLICK = `${AI_DESIGN_GEN_PREFIX}:shufflePromptClick`;

// AI Style transfer
export const AI_STYLE_TRANSFER_UPLOAD_CLICK = `${AI_PREFIX}:styleTransferUploadClick`;

// AI Copilot
const AI_COPILOT_PREFIX = `${AI_PREFIX}Copilot`;
export const AI_COPILOT_OPEN = `${AI_COPILOT_PREFIX}:open`;
export const AI_COPILOT_CLOSE = `${AI_COPILOT_PREFIX}:close`;
export const AI_COPILOT_PALETTE_CLICK = `${AI_COPILOT_PREFIX}:paletteClick`;
export const AI_COPILOT_QUICK_ACTION_CLICK = `${AI_COPILOT_PREFIX}:quickActionClick`;
export const AI_COPILOT_BACK_BUTTON_CLICK = `${AI_COPILOT_PREFIX}:backButtonClick`;
export const AI_COPILOT_ACTION_EXECUTE = `${AI_COPILOT_PREFIX}:actionExecute`;
export const AI_COPILOT_TEMPLATE_CLICK = `${AI_COPILOT_PREFIX}:templateClick`;
export const AI_COPILOT_GRAPHIC_CLICK = `${AI_COPILOT_PREFIX}:graphicClick`;
export const AI_COPILOT_GENERATE_TEXT_CLICK = `${AI_COPILOT_PREFIX}:generateTextClick`;
export const AI_COPILOT_GENERATE_BULK_TEXT_CLICK = `${AI_COPILOT_PREFIX}:generateBulkTextClick`;
export const AI_COPILOT_LOAD_MORE_CLICK = `${AI_COPILOT_PREFIX}:loadMoreClick`;

// AI image sets gen
const AI_IMAGE_SETS_GEN_PREFIX = `${AI_PREFIX}ImageSetsGen`;
export const AI_IMAGE_SETS_AUTO_COMPLETE_PROMPT_CLICK = `${AI_IMAGE_SETS_GEN_PREFIX}:autoCompletePromptClick`;
export const AI_IMAGE_SETS_CLEAR_ALL_CLICK = `${AI_IMAGE_SETS_GEN_PREFIX}:clearAllClick`;
export const AI_IMAGE_SETS_UNDO_CLICK = `${AI_IMAGE_SETS_GEN_PREFIX}:undoClick`;

// AI erase & fill
const AI_ERASER = `${AI_PREFIX}Eraser`;
export const AI_ERASER_TOGGLE_CLICK = `${AI_ERASER}:toggleClick`;
export const AI_ERASER_CANCEL_CLICK = `${AI_ERASER}:cancelClick`;
export const AI_ERASER_EVENTS_LABEL = 'eraseAndFill';

// Outpainting
const AI_OUTPAINTING_PREFIX = `${AI_PREFIX}Outpainting`;
export const AI_OUTPAINTING_PANEL_OPENED = `${AI_OUTPAINTING_PREFIX}:panelOpened`;
export const AI_OUTPAINTING_STARTED = `${AI_OUTPAINTING_PREFIX}:started`;
export const AI_OUTPAINTING_COMPLETED = `${AI_OUTPAINTING_PREFIX}:completed`;
export const AI_OUTPAINTING_FAILED = `${AI_OUTPAINTING_PREFIX}:failed`;
export const AI_OUTPAINTING_CANCELLED = `${AI_OUTPAINTING_PREFIX}:cancelled`;

// Mockups
const MOCKUP_PREFIX = 'mockup';
export const MOCKUP_OPEN = `${MOCKUP_PREFIX}:open`;
export const MOCKUP_ADD = `${MOCKUP_PREFIX}:add`;
export const MOCKUP_DOWNLOAD = `${MOCKUP_PREFIX}:download`;
export const MOCKUP_SAVE_TO_UPLOADS = `${MOCKUP_PREFIX}:saveToUploads`;

// Licensing
const LICENSING_PREFIX = 'licensing';
export const LICENSING_ACCEPTED_TERMS = `${LICENSING_PREFIX}:acceptedTerms`;
export const LICENSING_DISMISSED_TERMS = `${LICENSING_PREFIX}:dismissedTerms`;

const SUBSCRIPTION_PREFIX = 'subscription';
export const SUBSCRIPTION_UPGRADE_SUCCESS = `${SUBSCRIPTION_PREFIX}:upgradeSuccess`;
export const SUBSCRIPTION_CANCEL = `${SUBSCRIPTION_PREFIX}:cancel`;
export const SUBSCRIPTION_SEE_SUCCESS = `${SUBSCRIPTION_PREFIX}:seeSuccess`;
export const SUBSCRIPTION_TRIAL_STARTED = `${SUBSCRIPTION_PREFIX}:trialSeeSuccess`;

const PAYMENT_PREFIX = 'payment';
export const PAYMENT_FAILED = `${PAYMENT_PREFIX}:failed`;

const OFFBOARDING_PREFIX = 'offboarding';
export const OFFBOARDING_REASON_SELECTION = `${OFFBOARDING_PREFIX}:reasonSelection`;

// Referrals
const REFERRALS_PREFIX = 'referrals';
export const REFERRALS_INVITE_FRIENDS = `${REFERRALS_PREFIX}:inviteFriends`;
export const REFERRALS_COPY_SHARE_LINK_TO_CLIPBOARD = `${REFERRALS_PREFIX}:copyShareLinkToClipboard`;
export enum ReferralsInviteFriendsLabels {
  AiMenu = 'aiMenu',
  ProfileMenu = 'profileMenu',
  SAP = 'sap',
  ProfilePage = 'profilePage',
}

// Marketing Presets
const MARKETING_PRESETS_PREFIX = 'marketingPresets';
export const PRESET_CLICK_MODAL = `${MARKETING_PRESETS_PREFIX}:modalClick`;
export const PRESET_CLICK_DROPDOWN = `${MARKETING_PRESETS_PREFIX}:dropdownClick`;

const INFINITE_CANVAS_ONBOARDING_PREFIX = 'infiniteCanvasOnboarding';
export const INFINITE_CANVAS_ONBOARDING_SEE = `${INFINITE_CANVAS_ONBOARDING_PREFIX}:see`;
export const INFINITE_CANVAS_ONBOARDING_STEP = `${INFINITE_CANVAS_ONBOARDING_PREFIX}:step`;

export const BOARDS_ADDED = 'boards:added';

export const CONTEXTBAR_SHOW_MORE = 'contextBar:showMore';

// Churn prevention screen
const PAYMENT_FAILED_MODAL_PREFIX = 'paymentFailedModal';
export const PAYMENT_FAILED_MODAL_SHOW = `${PAYMENT_FAILED_MODAL_PREFIX}:show`;
export const PAYMENT_FAILED_MODAL_SKIP_CLOSE = `${PAYMENT_FAILED_MODAL_PREFIX}:close`;
export const PAYMENT_FAILED_MODAL_DOWNGRADE = `${PAYMENT_FAILED_MODAL_PREFIX}:downgrade`;
export const PAYMENT_FAILED_MODAL_SUCCESS = `${PAYMENT_FAILED_MODAL_PREFIX}:success`;

// Libraries
const LIBRARIES_PREFIX = 'brandKits';
export const LIBRARIES_ADD = `${LIBRARIES_PREFIX}:create`;
export const LIBRARIES_UPDATE = `${LIBRARIES_PREFIX}:update`;
export const LIBRARIES_REMOVE = `${LIBRARIES_PREFIX}:remove`;

export const CREATE_PRESET = `${LIBRARIES_PREFIX}:createPreset`;
export const UPDATE_PRESET = `${LIBRARIES_PREFIX}:editPreset`;
export const DELETE_PRESET = `${LIBRARIES_PREFIX}:deletePreset`;

export const LINK_PRESET = `${LIBRARIES_PREFIX}:linkPreset`;
export const UNLINK_PRESET = `${LIBRARIES_PREFIX}:unlinkPreset`;

const LIBRARY_ASSET_PREFIX = 'libraryAsset';
export const LIBRARY_ASSET_CREATE = `${LIBRARY_ASSET_PREFIX}:create`;
export const LIBRARY_ASSET_CREATE_FROM_GROUP = `${LIBRARY_ASSET_PREFIX}:createFromGroup`;
export const LIBRARY_ASSET_UPDATE = `${LIBRARY_ASSET_PREFIX}:update`;
export const LIBRARY_ASSET_DELETE = `${LIBRARY_ASSET_PREFIX}:delete`;

export const LIBRARY_ASSET_ADD = `${LIBRARY_ASSET_PREFIX}:add`;
export const LIBRARY_ASSET_DETACH = `${LIBRARY_ASSET_PREFIX}:detach`;
export const LIBRARY_REMOVE = `${LIBRARY_ASSET_PREFIX}:remove`;

const FOCUS_MODE_PREFIX = 'focusMode';
export const FOCUS_MODE_ASCEND = `${FOCUS_MODE_PREFIX}:descend`;
export const FOCUS_MODE_DESCEND = `${FOCUS_MODE_PREFIX}:ascend`;

const DIRECT_CHECKOUT_REDIRECT_PREFIX = 'checkout:direct:redirect';
/** @knipignore - used in website */
export const DIRECT_CHECKOUT_REDIRECT_SUCCESS = `${DIRECT_CHECKOUT_REDIRECT_PREFIX}:success`;
/** @knipignore - used in website */
export const DIRECT_CHECKOUT_REDIRECT_FAILURE = `${DIRECT_CHECKOUT_REDIRECT_PREFIX}:failure`;

// CSAT
const CSAT_PREFIX = 'csat';
export const CSAT_SURVEY_SHOW = `${CSAT_PREFIX}:show`;
export const CSAT_SURVEY_SUBMIT = `${CSAT_PREFIX}:submit`;
export const CSAT_SURVEY_DISMISS = `${CSAT_PREFIX}:dismiss`;
export const CSAT_SURVEY_CLICK_RATING = `${CSAT_PREFIX}:clickRating`;
export const CSAT_SURVEY_WRITE_FEEDBACK = `${CSAT_PREFIX}:writeFeedback`;

// Replace element
const REPLACE_ELEMENT_PREFIX = 'replaceElement';
export const REPLACE_ELEMENT_CLICK = `${REPLACE_ELEMENT_PREFIX}:click`;

// Copy as png
const COPY_AS_PNG_PREFIX = 'copyAsPNG';
export const COPY_AS_PNG_CLICK = `${COPY_AS_PNG_PREFIX}:click`;

// Media popover
const MEDIA_POPOVER = 'mediaPopover';
export const MEDIA_POPOVER_OPEN = `${MEDIA_POPOVER}:open`;
export const MEDIA_POPOVER_WATCH_CLICK = `${MEDIA_POPOVER}:watchClick`;
export const ONBOARDING_VIDEO_CLOSE = `onboadingVideo:close`;

// eraser
const ERASER_PREFIX = 'eraser';
export const ERASER_ENTER = `${ERASER_PREFIX}:enter`;
export const ERASER_ERASE = `${ERASER_PREFIX}:erase`;
export const ERASER_CHANGE_SIZE = `${ERASER_PREFIX}:changeSize`;
export const ERASER_RASTERIZATION_WARNING = `${ERASER_PREFIX}:showRasterizationWarning`;
export const ERASER_RASTERIZE = `${ERASER_PREFIX}:rasterize`;

// loss of work error modal
const LOSS_OF_WORK_ERROR_PREFIX = 'lossOfWorkError';
export const LOSS_OF_WORK_ERROR_SHOW = `${LOSS_OF_WORK_ERROR_PREFIX}:show`;
export const LOSS_OF_WORK_ERROR_CLICK = `${LOSS_OF_WORK_ERROR_PREFIX}:click`;
export const LOSS_OF_WORK_ERROR_SUCCESS = `${LOSS_OF_WORK_ERROR_PREFIX}:success`;
export const LOSS_OF_WORK_ERROR_ERROR = `${LOSS_OF_WORK_ERROR_PREFIX}:close`;

// Collaboration
const COLLABORATION_PREFIX = 'collab';
const PRESENTATION_PREFIX = `${COLLABORATION_PREFIX}:presentation`;
const THREADS_PREFIX = `${COLLABORATION_PREFIX}:thread`;
export const PRESENTATION_RESTART = `${PRESENTATION_PREFIX}:restart`;
export const PRESENTATION_SLIDE_VIEW = `${PRESENTATION_PREFIX}:slideView`;
export const THREAD_CREATED = `${THREADS_PREFIX}:create`;
export const THREAD_REPLY = `${THREADS_PREFIX}:reply`;

const SHARE_ACCESS_PREFIX = `${COLLABORATION_PREFIX}:share`;
export const SHARE_ACCESS_COPY_LINK = `${SHARE_ACCESS_PREFIX}:copyLink`;
export const SHARE_ACCESS_SEND_INVITE = `${SHARE_ACCESS_PREFIX}:sendInvite`;

// Template author
export const TEMPLATE_AUTHOR_CLICK = `template:author:click`;

// Template export/share
export const EXPORT_PREFIX = 'export';
export const EXPORT_OPEN = `${EXPORT_PREFIX}:open`;

// Rulers & guides
const RULERS_AND_GUIDES_PREFIX = 'rulersAndGuides';
export const RULERS_AND_GUIDES_TOGGLE_ON_OFF = `${RULERS_AND_GUIDES_PREFIX}:toggleOnOff`;
export const RULERS_AND_GUIDES_GUIDE_CREATE = `${RULERS_AND_GUIDES_PREFIX}:guideCreate`;
export const RULERS_AND_GUIDES_GUIDE_DELETE = `${RULERS_AND_GUIDES_PREFIX}:guideDelete`;

// Purchase
export const PURCHASE_CREDITS_LABEL = 'AIcredit';
const PURCHASE_PREFIX = 'purchase';
export const PURCHASE_SHOW = `${PURCHASE_PREFIX}:show`;
export const PURCHASE_CLICK = `${PURCHASE_PREFIX}:click`;
export const PURCHASE_SUCCESS = `${PURCHASE_PREFIX}:success`;

export const QUIET_MODE_TOGGLE = 'quietMode:toggle';

// Print margins:
const PRINT_MARGIN_PREFIX = 'printMargin';
export const PRINT_MARGIN_ADD = `${PRINT_MARGIN_PREFIX}:add`;
export const PRINT_MARGIN_REMOVE = `${PRINT_MARGIN_PREFIX}:remove`;
export const PRINT_MARGIN_UPDATE = `${PRINT_MARGIN_PREFIX}:update`;

// Print bleed & crop marks:
const PRINT_BLEED_PREFIX = 'printBleed';
export const PRINT_BLEED_ADD = `${PRINT_BLEED_PREFIX}:add`;
export const PRINT_BLEED_REMOVE = `${PRINT_BLEED_PREFIX}:remove`;
export const PRINT_BLEED_DOWNLOAD_TOGGLE = `${PRINT_BLEED_PREFIX}:download:bleed:toggle`;
export const PRINT_CROPMARKS_DOWNLOAD_TOGGLE = `${PRINT_BLEED_PREFIX}:download:cropmarks:toggle`;

// Onboarding Checklist
const ONBOARDING_CHECKLIST_PREFIX = 'onboardingChecklist';
export const ONBOARDING_CHECKLIST_UPDATE = `${ONBOARDING_CHECKLIST_PREFIX}:update`;
export const ONBOARDING_CHECKLIST_DISMISS = `${ONBOARDING_CHECKLIST_PREFIX}:dismiss`;
export const ONBOARDING_CHECKLIST_START = `${ONBOARDING_CHECKLIST_PREFIX}:start`;
export const ONBOARDING_CHECKLIST_CLAIM_REWARD = `${ONBOARDING_CHECKLIST_PREFIX}:claimReward`;

const COLLAB = 'collab';
export const COLLAB_OPEN_LINK = `${COLLAB}:share:openLink`;

// Elements panel
export const ELEMENTS_PANEL = 'elements';
export const ELEMENTS_PANEL_SEE_MORE_LIKE_THIS_CLICK = `${ELEMENTS_PANEL}:seeMoreLikeThis`;
export const ELEMENTS_PANEL_VIEW_SET_CLICK = `${ELEMENTS_PANEL}:viewSet`;
const ELEMENTS_PANEL_BOOKMARK_PREFIX = `${ELEMENTS_PANEL}:bookmark`;
export const ELEMENTS_PANEL_BOOKMARK = `${ELEMENTS_PANEL_BOOKMARK_PREFIX}:add`;
export const ELEMENTS_PANEL_UNBOOKMARK = `${ELEMENTS_PANEL_BOOKMARK_PREFIX}:remove`;

// Text flattening
export const TEXT_FLATTENING_SUCCESS = 'text:flatten:success';
export const TEXT_FLATTENING_FAILURE = 'text:flatten:failure';
